import * as PIXI from "pixi.js";
import {Sound} from "./Sound";
import {app, events} from "../../utils/pixiApp";
import {Question} from "./Question";
import {Balance} from "./Balance";
import {getDeviceMedia} from "../../utils/sizes";

const sizes = {
    web: {
        height: 80
    },
    mobile: {
        height: 56
    }
}

export class Header extends PIXI.Container {

    constructor() {
        super();
        this.media = sizes[getDeviceMedia(app.screen.width)]
        const height = this.media.height
        this.position.set(0,0);
        this.setSize(app.screen.width, height)
        this.rect = new PIXI.Graphics()
            .rect(0, 0, app.screen.width, height)
            .fill('rgba(2, 19, 32, .2)');

        this.sound = new Sound(height);
        this.question = new Question(height);

        this.balance = new Balance(height);
        this.addChild(this.rect, this.sound, this.question, this.balance)

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    resizeView() {
        if(this.getSize().width !== app.screen.width) {
            this.rect.clear()
            this.rect
                .rect(0, 0, app.screen.width, sizes[getDeviceMedia(app.screen.width)].height)
                .fill('rgba(2, 19, 32, .2)');
        }
    }
}